<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section epub:type="epigraph" role="doc-epigraph">
<p class="SP"> </p>
<p class="BRK4_Page_break"><span aria-label="vii" id="pg_vii" role="doc-pagebreak"></span></p>
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="EP1">Evil is unspectacular and always human,</p>
<p class="EP1">And shares our bed and eats at our own table</p>
<p class="EPA1">—W. H. Auden, “Herman Melville”</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?6148faec